// extracted by mini-css-extract-plugin
module.exports = {"timeIndicator":"TimeIndicator_timeIndicator__2Yv-i","dot":"TimeIndicator_dot__1cv2b","dotTop":"TimeIndicator_dotTop__3UvpN","dotBottom":"TimeIndicator_dotBottom__1nun-"};